import { API_URL } from "config";
import Http from "util/https";
import { SaveCompanySettingParams } from "../types";

/**
 * ジョイフル用企業設定登録、更新、削除APIを呼び出します
 * @param params 企業操作リクエストパラメータ
 * @returns {Promise<number>} レスポンスデータ
 */
const settingCompanyDataApi = async (params: SaveCompanySettingParams): Promise<number> => {
  console.log('settingCompanyDataApi params:', params);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/company/setting`;
  const res = await http.post<void>(url, params);
  console.log(res);

  return res.status;
};

export default settingCompanyDataApi;
